module.exports = __webpack_public_path__ + "static/cuz-c61a888a73b7466042cb5d06d111981a.jpg";